import { render, staticRenderFns } from "./OksReport.vue?vue&type=template&id=bcc38bec&scoped=true&"
import script from "./OksReport.vue?vue&type=script&lang=js&"
export * from "./OksReport.vue?vue&type=script&lang=js&"
import style0 from "./OksReport.vue?vue&type=style&index=0&id=bcc38bec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc38bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VProgressLinear,VTooltip})
